import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, Star, CheckCircle } from 'lucide-react';
import Image1 from "../Assets/WhatsApp Image 2025-12-22 at 11.02.18 PM.jpeg"

const TestimonialSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      name: "Sanjay Skanda",
      verified: true,
      date: "6/11/2025",
      location: "Bangalore",
      title: "Travelled to Bangalore",
      rating: 5,
      review: "I took a TT for one day trip and the quality of vehicle was good, the driver was experienced. It's was a nice experience. Thank you!",
      image: Image1
    },
    {
      name: "Priya Sharma",
      verified: true,
      date: "5/28/2025",
      location: "Mumbai",
      title: "Corporate Event Transfer",
      rating: 5,
      review: "Excellent service! The 13 seater Urbania was perfect for our team outing. Clean, comfortable, and the driver was very professional. Highly recommended!",
      image: Image1
    },
    {
      name: "Rahul Mehta",
      verified: true,
      date: "5/15/2025",
      location: "Delhi",
      title: "Family Trip to Agra",
      rating: 5,
      review: "Amazing experience with the Force Urbania. Spacious, comfortable seats, and great AC. Perfect for long distance family trips. Will book again!",
      image: Image1
    }
  ];

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const currentTestimonial = testimonials[currentIndex];

  return (
    <div className="min-h-fit bg-gradient-to-br from-gray-50 to-gray-100 py-10 px-4">
      <div className="max-w-5xl mx-auto">
        {/* Header - Medium size */}
        <h1 className="text-2xl md:text-3xl font-bold text-gray-900 text-center mb-10">
          What Our Customers Say About Our 13 Seater Force Urbania
        </h1>

        {/* Main Content */}
        <div className="flex flex-col lg:flex-row gap-6 items-center">
          {/* Testimonial Card */}
          <div className="w-full lg:w-1/2 bg-white rounded-2xl shadow-lg p-6 md:p-8 relative">
            {/* Customer Info */}
            <div className="flex items-start gap-4 mb-5">
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="text-lg font-bold text-gray-900">
                    {currentTestimonial.name}
                  </h3>
                  {currentTestimonial.verified && (
                    <CheckCircle className="w-4 h-4 text-blue-500 flex-shrink-0" />
                  )}
                </div>
                <p className="text-sm text-gray-500">
                  {currentTestimonial.date} | {currentTestimonial.location}
                </p>
              </div>
            </div>

            {/* Trip Title */}
            <h4 className="text-xl font-semibold text-gray-800 mb-4">
              {currentTestimonial.title}
            </h4>

            {/* Rating Badge */}
            <div className="inline-flex items-center gap-2 bg-blue-500 text-white px-4 py-2 rounded-lg mb-4">
              <Star className="w-4 h-4 fill-current" />
              <span className="font-bold">{currentTestimonial.rating}/5</span>
            </div>

            {/* Star Rating */}
            <div className="flex gap-1 mb-5">
              {[...Array(5)].map((_, i) => (
                <Star
                  key={i}
                  className="w-5 h-5 fill-yellow-400 text-yellow-400"
                />
              ))}
            </div>

            {/* Review Text */}
            <p className="text-gray-700 text-base leading-relaxed mb-6">
              {currentTestimonial.review}
            </p>

            {/* Navigation Buttons */}
            <div className="flex items-center justify-between mt-6">
              <button
                onClick={prevSlide}
                className="w-10 h-10 rounded-full border-2 border-gray-300 flex items-center justify-center hover:bg-gray-100 transition-colors"
                aria-label="Previous testimonial"
              >
                <ChevronLeft className="w-5 h-5 text-gray-600" />
              </button>

              {/* Dots Indicator */}
              <div className="flex gap-2">
                {testimonials.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentIndex(index)}
                    className={`w-2.5 h-2.5 rounded-full transition-all ${
                      index === currentIndex
                        ? 'bg-blue-500 w-6'
                        : 'bg-gray-300'
                    }`}
                    aria-label={`Go to testimonial ${index + 1}`}
                  />
                ))}
              </div>

              <button
                onClick={nextSlide}
                className="w-10 h-10 rounded-full border-2 border-gray-300 flex items-center justify-center hover:bg-gray-100 transition-colors"
                aria-label="Next testimonial"
              >
                <ChevronRight className="w-5 h-5 text-gray-600" />
              </button>
            </div>
          </div>

          {/* Image Section */}
          <div className="w-full lg:w-1/2">
            <div className="relative rounded-2xl overflow-hidden shadow-lg aspect-[4/3]">
              <img
                src={currentTestimonial.image}
                alt="Force Urbania with happy customers"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
              <div className="absolute bottom-4 left-4 text-white">
                <p className="text-sm font-semibold bg-blue-600 px-3 py-1 rounded-full inline-block">
                  Travel with Us Since Always
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Stats */}
        <div className="mt-10 text-center">
          <div className="inline-flex flex-wrap items-center justify-center gap-6 md:gap-8 text-gray-600">
            <div className="text-center px-4">
              <p className="text-2xl font-bold text-gray-900">500+</p>
              <p className="text-sm">Happy Customers</p>
            </div>
            <div className="hidden md:block w-px h-10 bg-gray-300" />
            <div className="text-center px-4">
              <p className="text-2xl font-bold text-gray-900">4.9/5</p>
              <p className="text-sm">Average Rating</p>
            </div>
            <div className="hidden md:block w-px h-10 bg-gray-300" />
            <div className="text-center px-4">
              <p className="text-2xl font-bold text-gray-900">1000+</p>
              <p className="text-sm">Trips Completed</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialSlider;